var a={small:20,medium:24,large:24};export{a as ICON_SIZES};
